import { Controller } from "@hotwired/stimulus";

/**
 * News feed — a long text folds after five lines; « See more » unfolds it in
 * place. The button only shows when the text is actually cut.
 */
export default class extends Controller {
  static targets = ["body", "toggle"];

  connect() {
    requestAnimationFrame(() => this.measure());
  }

  measure() {
    const cut = this.bodyTarget.scrollHeight > this.bodyTarget.clientHeight + 2;
    this.toggleTarget.hidden = !cut && !this.element.classList.contains("is-open");
  }

  toggle() {
    const open = this.element.classList.toggle("is-open");
    this.toggleTarget.textContent = open ? this.toggleTarget.dataset.less : this.toggleTarget.dataset.more;
    this.toggleTarget.setAttribute("aria-expanded", String(open));
  }
}
